module.exports = __webpack_public_path__ + "img/14.23cfa6ed.png";